import { Divider, Grid, useMediaQuery, useTheme } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
import genericPage from '../../assets/images/genericPage.png';
import { StyledDescription } from '../../components/StyledDescription';
import { StyledTitle } from '../../components/StyledTitle';
import { useLoaderContext } from '../../contexts/LoaderContext';
import { _ } from '../../shared/utils';

export const AcceptedPromoPage: React.FC = () => {

    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up(970));
    const setLoader = useLoaderContext();

    React.useEffect(() => {
        setLoader(false);
    }, []);

    return (
        <Grid height="100%" container>
            {matches && (
                <Grid sm={5} sx={{ backgroundColor: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center' }} item>
                    <img src={genericPage} width="450" alt='genericPage' />
                </Grid>
            )}
            <Grid
                sm={matches ? 7 : 12}
                sx={{ background: "#f2f2f2" }}
                item
            >
                <Box
                    display="flex"
                    justifyContent="center"
                    flexDirection="column"
                    gap={2}
                    overflow="auto"
                    height="100%"
                >
                    <StyledTitle>
                        IMPORTANTE!
                    </StyledTitle>
                    <Divider orientation="horizontal" />
                    <StyledDescription>
                        Hai sottoscritto la promozione esclusiva per l&#39;offerta relativa al modulo software "Concordato Preventivo Biennale"!
                        {/*La tua Azienda ha gi&agrave; sottoscritto la promozione esclusiva per l&#39;offerta relativa al modulo software "Concordato Preventivo Biennale".*/}
                        <br />
                        <br />
                        {/*Ti informiamo che &egrave; stata inviata gi&agrave; una PEC con i dettagli delle condizioni di acquisto.*/}
                        Ti informiamo che ti abbiamo gi&agrave; inviato una PEC con i dettagli delle condizioni di acquisto.
                    </StyledDescription>
                </Box>
            </Grid>
        </Grid>
    );
};
